module.exports = "/images/6.jpg?8af8ce2a9eab6cf54d70d6f69dd75df3";